import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectFormComponent } from 'app/modules/project/components/project-form/project-form.component';
import { ProjectDetailComponent } from 'app/modules/project/components/project-detail/project-detail.component';
import { DetailDetailComponent } from 'app/modules/project/components/detail-detail/detail-detail.component';
import { ProjectResolver } from 'app/modules/project/resolvers/project-resolver';
import { DetailResolver } from 'app/modules/project/resolvers/detail-resolver';
import { DetailFormContainerComponent } from 'app/modules/project/components/detail-form-container/detail-form-container.component';
import { AuthGuard } from '../auth/guards/auth.guard';
import { RoleGuard } from '../auth/guards/role.guard';

const authRoles = ['administrator', 'archive-editor'];

const routes: Routes = [
  {
    path: 'project',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'add',
        canActivate: [RoleGuard],
        data: {
          authorizedRoles: authRoles,
        },
        component: ProjectFormComponent,
      },
      {
        path: 'add/:id',
        canActivate: [RoleGuard],
        data: {
          authorizedRoles: authRoles,
        },
        component: ProjectFormComponent,
      },
    ],
  },
  {
    path: 'detail',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'details/page/1',
        pathMatch: 'full',
      },
      {
        path: 'add',
        canActivate: [RoleGuard],
        data: {
          authorizedRoles: authRoles,
        },
        component: DetailFormContainerComponent,
      },
      {
        path: 'add/:id',
        canActivate: [RoleGuard],
        data: {
          authorizedRoles: authRoles,
        },
        component: DetailFormContainerComponent,
      },
    ],
  },
  {
    path: 'project/:id',
    canActivate: [AuthGuard],
    component: ProjectDetailComponent,
    resolve: {
      project: ProjectResolver,
    },
  },
  {
    path: 'detail/:id',
    canActivate: [AuthGuard],
    component: DetailDetailComponent,
    resolve: {
      detail: DetailResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class ProjectRoutingModule {}
